import { useDispatch } from 'react-redux';
import appActions from '../redux/app/actions';
import Rox from 'rox-browser';
import CONFIG from '../settings';
import { useCallback, useEffect } from 'react';

const { setSystemFlags } = appActions;

const flags = {
  enableTutorial: new Rox.Flag(),
  enableCottonGrowth: new Rox.Flag(),
  enableIndependentVariables: new Rox.Flag(),
  enableCustomVariables: new Rox.Flag(),
  enableAliases: new Rox.Flag(),
  locationFlag: new Rox.Flag(),
  characteristicIndicatorFormFlag: new Rox.Flag(),
  enableLocationCrop: new Rox.Flag(),
  useVirtualSelectMethodologyModal: new Rox.Flag(),
  enableCompanyVirtualSelect: new Rox.Flag(),
  enableExtraDimensions: new Rox.Flag(),
  enableServiceProvidersPage: new Rox.Flag(),
  addCharacteristicsIndicator: new Rox.Flag(),
  enablingNewLanguages: new Rox.Flag(),
  cloneTrap: new Rox.Flag(),
  filterFixedPointsByCompany: new Rox.Flag(),
  filterMethodologiesByCompany: new Rox.Flag(),
  enableNewFieldsInCharacteristicForScoutingUSA: new Rox.Flag(),
  newFieldsToSMDLRules: new Rox.Flag(),
  enableIndicatorSeparation: new Rox.Flag(),
  singleUseTrap: new Rox.Flag(),
  enableMonitoringDays: new Rox.Flag(),
  showWarningCloningMethodologyAreaVariable: new Rox.Flag(),
  userManagementDiseaseRisk: new Rox.Flag(),
  positiveDiagnostic: new Rox.Flag(),
  readMethodology: new Rox.Flag(),
  specialCharactersOnCategories: new Rox.Flag(),
  ReactQueryDevTools: new Rox.Flag(),
  P40_19905_SHOW_PERMISSION_QUALIMETRE: new Rox.Flag(),
  P40_29585_integrate_web_panel_with_RBAC: new Rox.Flag(false),
  P40_14587_variables_validation: new Rox.Flag(false),
  P40_29584_USE_RBAC_CONTROLE_CERTO: new Rox.Flag(false),
  P40_33556_LIMIT_CHARACTERISTICS_NUMBER: new Rox.Flag(true),
  P40_37155_SAVE_CHARACTERISTIC_WITH_INDICATOR: new Rox.Flag(false),
  P40_38140_PREVENT_DUPLICITY_OF_INDICATOR_WITHOUT_ASSOCIATED_CHARACTERISTICS: new Rox.Flag(false),
  P40_36618_DEFAULT_VALUE: new Rox.Flag(),
  P40_39706_CLONE_CHARACTERISTICS_INDICATORS: new Rox.Flag(false),
  P40_41997_YIELD_ESTIMATION_SETUP: new Rox.Flag(false),
  P40_46421_AREA_VARIABLES_CONFIGURATION: new Rox.Flag(false),
  P40_48670_ENABLE_METHODOLOGY_V2: new Rox.Flag(false),
  P40_48651_INSPECTION_GROUP_MANDATORY_PHOTO: new Rox.Flag(false),
  P40_49203_LOAD_ALL_AREA_VARIABLES: new Rox.Flag(false),
  P40_49603_DISPLAY_ID_IN_MULTI_PHENOMENON_INDICATOR: new Rox.Flag(false),
  P40_49577_hide_invitations: new Rox.Flag(false),
  P40_49577_show_invitations_by_userid: new Rox.RoxString('[]'),
  P40_50021_ENABLE_CHARACTERISTIC_CLUSTERING: new Rox.Flag(false),
  P40_52117_login_with_SSO: new Rox.Flag(false),
  P40_64531_CLEAR_LOCATION_CROP_ON_SCHEMA_CLONE: new Rox.Flag(false),
  P40_55830_AREA_VARIABLES_SCHEMA: new Rox.Flag(false),
  P40_51991_ADD_PRIORITY_TO_INDICATORS: new Rox.Flag(false),
  P40_58564_WORKSPACE_SELECTOR: new Rox.Flag(false),
  P40_59408_ENABLE_ORGANIZATIONS_V2: new Rox.Flag(false),
  P40_60446_MEASUREMENT_MAINTENANCE_BY_INSPECTION: new Rox.Flag(false),
  P40_55417_MEASURES_VIA_OBSERVATION_SERVICE: new Rox.Flag(false),
  P40_61252_SEEDS_SETUP_WORKSPACE_SCOPE: new Rox.Flag(false),
  P40_62367_METHODOLOGY_MGT_MFE: new Rox.Flag(false),
  P40_55336_MIGRATED_CONFIGURATION_WRITES: new Rox.RoxString('[]')
};

const initRollout = async () => {
  const options = {};

  if (!Rox.flags.length) {
    Rox.register('', flags);
  }

  await Rox.setup(CONFIG.rolloutKey || '', options);
};

const useInitRollout = () => {
  const dispatch = useDispatch();

  const configureFlags = useCallback(() => {
    dispatch(
      setSystemFlags({
        enableCottonGrowth: flags.enableCottonGrowth.isEnabled(),
        enableIndependentVariables: flags.enableIndependentVariables.isEnabled(),
        enableCustomVariables: flags.enableCustomVariables.isEnabled(),
        enableAliases: flags.enableAliases.isEnabled(),
        locationFlag: flags.locationFlag.isEnabled(),
        characteristicIndicatorFormFlag: flags.characteristicIndicatorFormFlag.isEnabled(),
        enableLocationCrop: flags.enableLocationCrop.isEnabled(),
        useVirtualSelectMethodologyModal: flags.useVirtualSelectMethodologyModal.isEnabled(),
        enableCompanyVirtualSelect: flags.enableCompanyVirtualSelect.isEnabled(),
        enableExtraDimensions: flags.enableExtraDimensions.isEnabled(),
        enableServiceProvidersPage: flags.enableServiceProvidersPage.isEnabled(),
        addCharacteristicsIndicator: flags.addCharacteristicsIndicator.isEnabled(),
        enablingNewLanguages: flags.enablingNewLanguages.isEnabled(),
        cloneTrap: flags.cloneTrap.isEnabled(),
        filterFixedPointsByCompany: flags.filterFixedPointsByCompany.isEnabled(),
        filterMethodologiesByCompany: flags.filterMethodologiesByCompany.isEnabled(),
        enableNewFieldsInCharacteristicForScoutingUSA: flags.enableNewFieldsInCharacteristicForScoutingUSA.isEnabled(),
        newFieldsToSMDLRules: flags.newFieldsToSMDLRules.isEnabled(),
        enableIndicatorSeparation: flags.enableIndicatorSeparation.isEnabled(),
        singleUseTrap: flags.singleUseTrap.isEnabled(),
        enableMonitoringDays: flags.enableMonitoringDays.isEnabled(),
        showWarningCloningMethodologyAreaVariable: flags.showWarningCloningMethodologyAreaVariable.isEnabled(),
        userManagementDiseaseRisk: flags.userManagementDiseaseRisk.isEnabled(),
        positiveDiagnostic: flags.positiveDiagnostic.isEnabled(),
        readMethodology: flags.readMethodology.isEnabled(),
        specialCharactersOnCategories: flags.specialCharactersOnCategories.isEnabled(),
        ReactQueryDevTools: flags.ReactQueryDevTools.isEnabled(),
        P40_19905_SHOW_PERMISSION_QUALIMETRE: flags.P40_19905_SHOW_PERMISSION_QUALIMETRE.isEnabled(),
        P40_29585_integrate_web_panel_with_RBAC: flags.P40_29585_integrate_web_panel_with_RBAC.isEnabled(),
        P40_14587_variables_validation: flags.P40_14587_variables_validation.isEnabled(),
        P40_29584_USE_RBAC_CONTROLE_CERTO: flags.P40_29584_USE_RBAC_CONTROLE_CERTO.isEnabled(),
        P40_33556_LIMIT_CHARACTERISTICS_NUMBER: flags.P40_33556_LIMIT_CHARACTERISTICS_NUMBER.isEnabled(),
        P40_37155_SAVE_CHARACTERISTIC_WITH_INDICATOR: flags.P40_37155_SAVE_CHARACTERISTIC_WITH_INDICATOR.isEnabled(),
        P40_38140_PREVENT_DUPLICITY_OF_INDICATOR_WITHOUT_ASSOCIATED_CHARACTERISTICS:
          flags.P40_38140_PREVENT_DUPLICITY_OF_INDICATOR_WITHOUT_ASSOCIATED_CHARACTERISTICS.isEnabled(),
        P40_36618_DEFAULT_VALUE: flags.P40_36618_DEFAULT_VALUE.isEnabled(),
        P40_39706_CLONE_CHARACTERISTICS_INDICATORS: flags.P40_39706_CLONE_CHARACTERISTICS_INDICATORS.isEnabled(),
        P40_41997_YIELD_ESTIMATION_SETUP: flags.P40_41997_YIELD_ESTIMATION_SETUP.isEnabled(),
        P40_46421_AREA_VARIABLES_CONFIGURATION: flags.P40_46421_AREA_VARIABLES_CONFIGURATION.isEnabled(),
        P40_48670_ENABLE_METHODOLOGY_V2: flags.P40_48670_ENABLE_METHODOLOGY_V2.isEnabled(),
        P40_48651_INSPECTION_GROUP_MANDATORY_PHOTO: flags.P40_48651_INSPECTION_GROUP_MANDATORY_PHOTO.isEnabled(),
        P40_49203_LOAD_ALL_AREA_VARIABLES: flags.P40_49203_LOAD_ALL_AREA_VARIABLES.isEnabled(),
        P40_49603_DISPLAY_ID_IN_MULTI_PHENOMENON_INDICATOR: flags.P40_49603_DISPLAY_ID_IN_MULTI_PHENOMENON_INDICATOR.isEnabled(),
        P40_49577_hide_invitations: flags.P40_49577_hide_invitations.isEnabled(),
        P40_49577_show_invitations_by_userid: flags.P40_49577_show_invitations_by_userid.getValue() || '[]',
        P40_50021_ENABLE_CHARACTERISTIC_CLUSTERING: flags.P40_50021_ENABLE_CHARACTERISTIC_CLUSTERING.isEnabled(),
        P40_52117_login_with_SSO: flags.P40_52117_login_with_SSO.isEnabled(),
        P40_64531_CLEAR_LOCATION_CROP_ON_SCHEMA_CLONE: flags.P40_64531_CLEAR_LOCATION_CROP_ON_SCHEMA_CLONE.isEnabled(),
        P40_55830_AREA_VARIABLES_SCHEMA: flags.P40_55830_AREA_VARIABLES_SCHEMA.isEnabled(),
        P40_51991_ADD_PRIORITY_TO_INDICATORS: flags.P40_51991_ADD_PRIORITY_TO_INDICATORS.isEnabled(),
        P40_58564_WORKSPACE_SELECTOR: flags.P40_58564_WORKSPACE_SELECTOR.isEnabled(),
        P40_59408_ENABLE_ORGANIZATIONS_V2: flags.P40_59408_ENABLE_ORGANIZATIONS_V2.isEnabled(),
        P40_60446_MEASUREMENT_MAINTENANCE_BY_INSPECTION: flags.P40_60446_MEASUREMENT_MAINTENANCE_BY_INSPECTION.isEnabled(),
        P40_55417_MEASURES_VIA_OBSERVATION_SERVICE: flags.P40_55417_MEASURES_VIA_OBSERVATION_SERVICE.isEnabled(),
        P40_61252_SEEDS_SETUP_WORKSPACE_SCOPE: flags.P40_61252_SEEDS_SETUP_WORKSPACE_SCOPE.isEnabled(),
        P40_62367_METHODOLOGY_MGT_MFE: flags.P40_62367_METHODOLOGY_MGT_MFE.isEnabled(),
        P40_55336_MIGRATED_CONFIGURATION_WRITES: flags.P40_55336_MIGRATED_CONFIGURATION_WRITES.getValue() || '[]'
      })
    );
  }, [dispatch]);

  useEffect(() => {
    initRollout().then(() => {
      configureFlags();
    });
  }, [configureFlags]);
};

export default useInitRollout;
